sliderFieldsDirective = angular.module('sliderfields.setting', [])

sliderFieldsDirective.filter 'toArray',["$timeout", ($timeout) ->
  (obj) ->
    result = []
    _.each obj, (val, hash) ->
      result.push {name: val, value: hash}
    result
]

sliderFieldsDirective.directive "sliderFieldsSetting", ["$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "ContentEditable", "Widget", "blockEditDialog", "Slider", "Restangular", ($window, $timeout, $compile, $templateCache, ns, translitService, ContentEditable, Widget, blockEditDialog, Slider, Restangular) ->
  restrict: "A",
  scope: {data: "=ngModel"},
  templateUrl: "#{settingFolder}/sliderfields/template.jade"
  link: (scope, element, attrs, ngModel) ->
    id = attrs.widgetId
    widgetElWrapper = angular.element("[data-block-id=#{id}]").find ns.widgetWrapperClass
    scope.slider = angular.copy scope.data
    slideWithListFields = false
    sliderElement = widgetElWrapper.find('.strw-slider')[0].swiper

    sectionId = blockEditDialog.getSectionId id:id

    if widgetElWrapper.find('.gallery-thumbs')[0]
      newSwiperThumbs = widgetElWrapper.find('.gallery-thumbs')[0].swiper

    getNotDestroyedFieldRnd = ->
      fields = []
      _.each scope.slider.photos_attributes, (field, index) ->
        if !field._destroy
          fields.push index
      if fields.length > 0
        fields[fields.length-1]
      else
        0

    trimNbsp = (fields) ->
      for field in fields
        field.caption = field.caption.replace(/&nbsp;/gi,'')
      fields

    scope.currentField = getNotDestroyedFieldRnd()

    availableFieldIndex = (slider) ->
      slide = widgetElWrapper.find(".swiper-slide-active")
      sliderId = $(slide).data "slide-id"
      for photo,index in scope.slider.photos_attributes
        if photo.id is sliderId
          return index

    _onSlideChangeStart = (slider) ->
      if !slideWithListFields
        $timeout ->
          scope.currentField = availableFieldIndex slider

    reInitSlider = (slider) ->
      sliders = Slider.initSlider 0, slider, _onSlideChangeStart
      sliderElement = sliders[0]
      newSwiperThumbs = sliders[1]

    reInitSlider widgetElWrapper.find(".#{ns.sliderClass}")

    scope.setCurrentSlide = ($index) ->
      scope.currentField = $index
      slideId = scope.slider.photos_attributes[scope.currentField].id
      index = $("[data-slide-id='#{slideId}']").index()
      slideWithListFields = true
      sliderElement.slideTo index
      slideWithListFields = false

    scope.add = ->
      sectionId = blockEditDialog.getSectionId id:id
      params =
        photos_attributes: [{remote_file_url: "#{Restangular.configuration.baseUrl}/assets/widgets/slider/img3.jpg"}]
      Widget.createItem(sectionId, id, params).then (data) ->
        newSlide = data.photos_attributes[data.photos_attributes.length-1]
        scope.slider.photos_attributes.push newSlide
        length = scope.slider.photos_attributes.length
        newSlideHTML = "
          <div class='swiper-slide strw-slider__item' data-slide-id='#{newSlide.id}'>
            <div class='strw-slider__image-wrapper'>
              <div class='strw-slider__image strw-slider__image_cover' style='background-image: url(#{newSlide.file_url})'></div>
            </div>
            <p class='strw-slider__caption' contenteditable='false' data-access='photos_attributes.#{length-1}.caption'>#{newSlide.caption}</p>
          </div>
          "
        newSlideThumbHTML = "
          <div class='swiper-slide strw-slider__item' data-slide-id='#{newSlide.id}'>
            <div class='strw-slider__image-wrapper'>
              <div class='strw-slider__image strw-slider__image_cover strw-slider__image_cover-thumb' style='background-image: url(#{newSlide.file_url})'></div>
            </div>
          </div>
          "
        sliderElement.appendSlide newSlideHTML
        newSwiperThumbs.appendSlide newSlideThumbHTML if newSwiperThumbs
        scope.setCurrentSlide length - 1, newSlide
        setSlidesStyles scope.data.slides_style
        ContentEditable.bind false, true, id

    scope.fieldsLength = (fields) ->
      destroyed = _.filter fields, _destroy: true
      fields.length - destroyed.length

    removeCurrentSlide = ->
      slideId = scope.slider.photos_attributes[scope.currentField].id
      index = $("[data-slide-id='#{slideId}']").index()
      sliderElement.removeSlide index
      newSwiperThumbs.removeSlide index if newSwiperThumbs

    scope.remove = ->
      scope.slider.photos_attributes[scope.currentField]._destroy = true
      removeCurrentSlide()
      scope.setCurrentSlide getNotDestroyedFieldRnd()

    listener1 = scope.$watch "slider.photos_attributes", (newVal, oldVal) ->
      scope.data.photos_attributes = trimNbsp newVal
    , true

    listener2 = scope.$watch "data", (newVal, oldVal) ->
      renderCaption newVal
      renderPhotos newVal
      _onChangeSliderSettings newVal, oldVal
    , true

    scope.$on "$destroy", ->
      listener1()
      listener2()

    _onChangeSliderSettings = (newVal, oldVal) ->
      if !angular.equals(newVal.settings, oldVal.settings)
        thumbsSliderRender newVal.settings
        widgetSlider = widgetElWrapper.find(".#{ns.sliderClass}")
        settings = angular.copy newVal.settings
        widgetSlider.data "slider-settings", settings
        reInitSlider widgetElWrapper.find(".#{ns.sliderClass}")
      if !angular.equals(newVal.slides_style, oldVal.slides_style)
        setSlidesStyles newVal.slides_style

    thumbsSliderRender = (newVal) ->
      if newVal.thumbs
        if !widgetElWrapper.find(".gallery-thumbs").length
          newSliderThumbsHTML = widgetElWrapper.find(".#{ns.sliderClass}").clone()
          newSliderThumbsHTML
            .removeClass "strw-slider"
            .removeAttr "data-slider-settings"
            .addClass "gallery-thumbs"
          newSliderThumbsHTML.find(".strw-slider__image")
            .addClass "strw-slider__image_cover-thumb"
            .css "height", "auto"
          newSliderThumbsHTML.find(".swiper-slide").removeAttr "style"
          newSliderThumbsHTML.find(".swiper-button-prev").remove()
          newSliderThumbsHTML.find(".swiper-button-next").remove()
          newSliderThumbsHTML.find(".swiper-pagination").remove()
          newSliderThumbsHTML.find(".strw-slider__caption").remove()
          widgetElWrapper.find(".#{ns.sliderClass}").after newSliderThumbsHTML
      else
        widgetElWrapper.find(".gallery-thumbs").remove()
        return

    setSlidesStyles = (newVal) ->
      widgetSlider = widgetElWrapper.find(".#{ns.sliderClass}")
      widgetSlider.find(".#{ns.sliderSlideClass}").css newVal

    renderPhotos = (newVal) ->
      _.each newVal.photos_attributes, (photo) ->
        $("[data-slide-id='#{photo.id}']").find(".strw-slider__image_cover").css "background-image", "url('#{photo.file_url}')"

    renderCaption = (newVal) ->
      pagination = widgetElWrapper.find(".swiper-pagination")
      caption = widgetElWrapper.find(".strw-slider__caption")
      if newVal.show_caption
        caption.show()
        pagination.addClass "swiper__with-caption"
      else
        pagination.removeClass "swiper__with-caption"
        caption.hide()
      caption.css newVal.caption_style

]



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/sliderfields/sliderfields.directive.coffee